import styled from "styled-components";
import {Table} from "antd";

const JOKER_COLOR = "#c25368";
export const TableContainer = styled(Table)`
    width: 100%;
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const SlotTitleWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
`;

export const ShiftHourWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5px;
`;
export const SlotCellWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 200px;
    width: 90%;
    height: 40px;
    position: relative;
    padding: 10px !important;
`;

export const ShiftStartHour = styled.div`
    font-size: 14px;
    font-weight: bold;
`;

export const ShiftEndHour = styled.div`
    font-size: 12px;
`;

export const OtherPoolLink = styled.div`
    cursor: pointer;
    font-size: 12px;
    color: #c0defe;
    font-weight: bold;
    text-decoration: underline;
`;

export const SlotCellOverlay = styled.div`
    display: none;
    //display: flex;
    position: absolute;
    top: -1;
    left: -1;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    justify-content: center;
    align-items: center;

    color: #ffffff;

    z-index: 3;
    line-height: 1;
    transition: 0.4;
    & > div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #000000;
        color: #ffffff;
        opacity: 0.5;
        z-index: 2;
        line-height: 1;
    }
    & > span {
        z-index: 3;
    }
`;

export const ShiftCell = styled.div`
    top: 0 !important;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    //border: ${props => (props.disabled ? "unset" : "1px solid #999d9a")};

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    background-color: ${props => (props.disabled ? "#fafafa" : "initial")};

    font-weight: bold;
    transition: background-color 0.3s;
    transition: border 1s;
    &:hover {
        transition: border 0.1s;
        /* background-color: ${props => (props.disabled ? "initial" : "#a7dbde")}; */
        border: ${props => (props.disabled ? "unset" : "2px solid black")};
    }

    &:hover ${SlotCellOverlay} {
        display: flex;
    }
`;

export const ShiftIconWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    font-size: 22px;
    justify-content: center;
    align-items: center;
    z-index: 1;
`;

export const DurationProgressWrapper = styled.div`
    padding: 0px 20px 6px 20px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
`;

export const JokerCellOverlay = styled(SlotCellOverlay)`
    align-items: flex-end;
    padding-bottom: 5px;
    transition: 0.3;
    font-weight: bold;
`;

export const CourierNameCell = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    top: 0 !important;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    //border: ${props => (props.disabled ? "unset" : "1px solid #999d9a")};

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    background-color: ${props => (props.disabled ? "#fafafa" : "initial")};


    transition: background-color 0.3s;
    transition: border 1s;

    &>span{
        width: 100%;
        padding: 0px 10px;
    }
    &:hover {
        transition: border 0.1s;
        /* background-color: ${props => (props.disabled ? "initial" : "#a7dbde")}; */
        border: ${props => (props.disabled ? "unset" : "2px solid black")};
    }

    &:hover ${JokerCellOverlay} {
        display: ${props => (props?.disabled ? "none" : "flex")}
    }
    &:hover >span{
        padding: ${props => (props?.disabled ? "0px 10px" : "0px 8px")}
    }
`;
